import React from "react";
import AccountsTables from "layouts/AccountsTables";

export default function Accounts() {
    return <AccountsTables url="account/all" />;
}
